import React from "react";
import StyledMenu from "./StyledMenu";
import { Divider, MenuItem } from "@mui/material";

export default function OptionsMenu(props) {
  const { anchorEl, setAnchorEl, items, name } = props;

  const open = Boolean(anchorEl);

  return (
    <StyledMenu
      id={name || "options-menu"}
      MenuListProps={{
        "aria-labelledby": name ? `${name}-button` : "options-button",
      }}
      disableScrollLock
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
    >
      {items.map((item, index) =>
        !item ? (
          <></>
        ) : item?.divider ? (
          <Divider />
        ) : (
          <MenuItem
            key={index}
            onClick={
              item?.href
                ? () => {
                    if (item?.target) {
                      window.open(item.href, item.target);
                    } else {
                      window.location.assign(item.href);
                    }
                  }
                : item?.onClick
                ? item.onClick
                : null
            }
            {...item}
          >
            {item?.label}
          </MenuItem>
        )
      )}
    </StyledMenu>
  );
}
